import { useCallback, useState } from "react";
import DateRangePicker from "../../components/DateRangePicker/DateRangePicker";
import { HStack, Text, VStack } from "@chakra-ui/react";
import GroupSelector from "./components/GroupSelector";
import { DailyRVUTable } from "./components/DailyRVUTable";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { timeZoneFullNames } from "../../utils/timeZones";

dayjs.extend(utc);
dayjs.extend(timezone);

const RVUTrackerPage: React.FC = () => {
  const [dateFilter, setDateFilter] = useState<Date>(dayjs().startOf("day").toDate());
  const [groupFilter, setGroupFilter] = useState<string | undefined>();
  const [groupTimezone, setGroupTimezone] = useState<string | undefined>();

  const timezoneDisplay = groupTimezone ? timeZoneFullNames[groupTimezone] : undefined;

  const onDatesChange = useCallback(
    (dates: Date[]) => {
      if (dates.length === 1) {
        // Convert the selected date to the group's timezone if available
        const date = groupTimezone
          ? dayjs(dates[0]).tz(groupTimezone, true).toDate()
          : dayjs(dates[0]).toDate();
        setDateFilter(date);
      }
    },
    [groupTimezone],
  );

  const onGroupChange = useCallback((groupId: string, timezone: string | undefined) => {
    setGroupFilter(groupId);
    setGroupTimezone(timezone);
  }, []);

  return (
    <VStack align="stretch" spacing={6}>
      <HStack justify="space-between" align="flex-start">
        <VStack align="flex-start" spacing={1}>
          <Text textStyle="h5">RVU Tracker</Text>
          <Text textStyle="body" color="gray.400">
            {timezoneDisplay ? `Viewing in ${timezoneDisplay}` : ""}
          </Text>
        </VStack>
        <HStack>
          <GroupSelector onGroupSelected={onGroupChange} />
          <DateRangePicker
            initialDates={[dateFilter]}
            variant="single"
            disableClear
            buttonStyle={{
              minW: "fit-content",
              minH: "34px",
            }}
            onDatesChange={onDatesChange}
          />
        </HStack>
      </HStack>
      <DailyRVUTable date={dateFilter} groupId={groupFilter} />
    </VStack>
  );
};

export default RVUTrackerPage;
